import { api } from './client.js';

const unwrap = (resp) => resp.data?.data;

export const roadmapApi = {
  get: (projectKey, params) =>
    api.get(`/projects/${projectKey}/roadmap`, { params }).then(unwrap),
  updateEpicDates: (epicId, dates) =>
    api.patch(`/roadmap/epics/${epicId}/dates`, dates).then(unwrap),
};
